import React, { Component } from "react";

import { connect } from "react-redux";
import {
  cProducthideRightSidebar,
} from "../../../store/MaterialRequest/actions";

//SimpleBar
import SimpleBar from "simplebar-react";

// import { Link } from "react-router-dom";

import "./rightbar.scss";
import AddProducts from "../../MastersDashboard/Products/AddProducts";

class CustomProductRightbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [
        {
          id: "01",
          title: "Your order is placed",
          link: "#",
        },
        {
          id: "02",
          title: "Your order is placed",
          link: "#",
        },
        {
          id: "03",
          title: "Your order is placed",
          link: "#",
        },
      ],
      // layoutType: this.props.layoutType,
      // sidebarType: this.props.leftSideBarType,
      // layoutWidth: this.props.layoutWidth,
      // sidebarTheme: this.props.leftSideBarTheme,
      // topbarTheme: this.props.topbarTheme,
    };
    this.hideCPRightbar = this.hideCPRightbar.bind(this);
    // this.changeLayout = this.changeLayout.bind(this);
    // this.changeLayoutWidth = this.changeLayoutWidth.bind(this);
    // this.changeLeftSidebarTheme = this.changeLeftSidebarTheme.bind(this);
    // this.changeLeftSidebarType = this.changeLeftSidebarType.bind(this);
    // this.changeTopbarTheme = this.changeTopbarTheme.bind(this);
    // this.changeThemePreloader = this.changeThemePreloader.bind(this);
  }

  /**
   * Hides the right sidebar
   */
  hideCPRightbar(e) {
    e.preventDefault();
    this.props.cProducthideRightSidebar();
  }

  render() {
    return (
      <React.Fragment>
        <div className="cp-right-bar">
          <div className="h-100">
            <SimpleBar style={{ maxHeight: "100%" }}>
              <AddProducts
                CPmodel={true}
                openId={0}
                Close={this.hideCPRightbar}
              />
            </SimpleBar>
          </div>
        </div>

        <div className="CP-rightbar-overlay" onClick={this.hideCPRightbar}>
          {" "}
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default connect(mapStatetoProps, {
  cProducthideRightSidebar,
})(CustomProductRightbar);
